/**
 * Wrightsock: show colour sale dots only when that colour is on sale
 * with the currently selected Size (option 1).
 * Uses data-on-sale-with="Large,Extra Large," on colour labels.
 *
 * Dawn's <product-info> replaces <variant-selects> on option change, so we
 * use document-level listeners + a MutationObserver (not one-shot binds).
 */
(function () {
  function csvIncludes(csv, value) {
    if (!csv || value == null || value === '') return false;
    return csv
      .split(',')
      .map(function (part) {
        return part.trim();
      })
      .filter(Boolean)
      .some(function (part) {
        return part === value;
      });
  }

  function getSelectedSize(root) {
    var first = root.querySelector('.first_variant');
    if (!first) return null;
    var checked = first.querySelector('input[type="radio"]:checked');
    if (checked) return checked.value;
    var selectedOption = first.querySelector('select option:checked, select option[selected]');
    if (selectedOption) return selectedOption.value;
    return null;
  }

  function syncSaleBadges(root) {
    if (!root) return;
    var selectedSize = getSelectedSize(root);
    var labels = root.querySelectorAll('.second_variant [data-on-sale-with]');

    labels.forEach(function (label) {
      var csv = label.getAttribute('data-on-sale-with') || '';
      var onSale = selectedSize != null && csvIncludes(csv, selectedSize);
      var badge = label.querySelector('.variant-sale_badge');

      label.classList.toggle('is-on-sale', onSale);

      if (badge) {
        badge.classList.toggle('is-visible', onSale);
      }
    });
  }

  function syncAll() {
    document.querySelectorAll('variant-selects').forEach(syncSaleBadges);
  }

  var scheduled = null;
  function scheduleSync() {
    clearTimeout(scheduled);
    scheduled = setTimeout(syncAll, 30);
  }

  document.addEventListener(
    'change',
    function (event) {
      if (event.target && event.target.closest && event.target.closest('variant-selects')) {
        scheduleSync();
      }
    },
    true
  );

  document.addEventListener('shopify:section:load', scheduleSync);

  if (typeof MutationObserver !== 'undefined') {
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.type !== 'childList') continue;
        var nodes = [];
        m.addedNodes.forEach(function (n) {
          nodes.push(n);
        });
        m.removedNodes.forEach(function (n) {
          nodes.push(n);
        });
        for (var j = 0; j < nodes.length; j++) {
          var node = nodes[j];
          if (!node || node.nodeType !== 1) continue;
          if (
            node.matches &&
            (node.matches('variant-selects') ||
              node.matches('product-info') ||
              node.querySelector('variant-selects'))
          ) {
            scheduleSync();
            return;
          }
        }
      }
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAll);
  } else {
    syncAll();
  }
})();
